import AntIcon from "@/components/icons/AntIcon";
import { URLQuery } from "@/utils/queryUtils";
import { validationConstants, validations } from "@/utils/validationUtils";
import { Button, Col, Form, Input, Row } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { rowGutter } from "../../../../common/constants";
import { LifeInsuranceTariffGroupSelect } from "../../../enumerations/components/form/LifeInsuranceTariffGroupSelect";
import { LifeInsuranceTariffFilterPageRequest } from "../../types";

const colSpan = 6;

interface Props {
  searchParams: LifeInsuranceTariffFilterPageRequest;
}

export const LifeInsuranceTariffFilterForm = ({ searchParams }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [form] = Form.useForm<LifeInsuranceTariffFilterPageRequest>();

  useEffect(() => {
    form.setFieldsValue(searchParams);
  }, [searchParams, form]);

  const handleFilterSubmit = (filter: LifeInsuranceTariffFilterPageRequest) => {
    navigate(
      {
        search: URLQuery.searchParamsToString({
          searchParams: { ...filter, pageIndex: undefined },
          append: true,
        }),
      },
      { replace: true },
    );
  };

  return (
    <Form form={form} onFinish={handleFilterSubmit} layout="vertical" name="lifeInsuranceTariffSearchForm">
      <Row gutter={rowGutter} justify="center">
        <Col span={colSpan}>
          <Form.Item
            name="keyword"
            label={t("common.search")}
            rules={[
              validations.size(
                validationConstants.SEARCH_KEYWORD_MIN_LENGTH,
                validationConstants.SEARCH_KEYWORD_MAX_LENGTH,
              ),
            ]}
          >
            <Input allowClear placeholder={t("lifeInsuranceTariff.helpers.tariffSearchHint")} />
          </Form.Item>
        </Col>

        <Col span={colSpan}>
          <Form.Item name="groupIds" label={t("lifeInsuranceTariff.attrs.groupId")} rules={[validations.none]}>
            <LifeInsuranceTariffGroupSelect isMultiple allowClear />
          </Form.Item>
        </Col>

        <Col flex="110px" className="no-title-space">
          <Form.Item>
            <Button type="primary" htmlType="submit" icon={<AntIcon type="search" />}>
              {t("common.filter")}
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
